import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import SuccessSnackbar from '../../../shared/feedback/SuccessSnackbar';
import FailureSnackbar from '../../../shared/feedback/FailureSnackbar';
import { CloneOrderModal } from './CloneOrderModal';

interface IProps {
    orderId: number;
    show: boolean;
    onHide: () => void;
    onSuccess?: () => void;
}

export const CloneOrderFlow = (props: IProps) => {
    const [showSuccess, setShowSuccess] = React.useState(false);
    const [showFailure, setShowFailure] = React.useState(false);

    const handleResult = (success: boolean) => {
        if (success) {
            setShowSuccess(true);
            if (props.onSuccess) {
                props.onSuccess();
            }
        } else {
            setShowFailure(true);
        }
    };

    return (
        <>
            {props.show && (
                <CloneOrderModal
                    show={props.show}
                    onHide={props.onHide}
                    orderId={props.orderId}
                    onResult={handleResult}
                />
            )}

            <SuccessSnackbar
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                text={Translate('view-order/clone/modal/success')}
            />
            <FailureSnackbar
                open={showFailure}
                onClose={() => setShowFailure(false)}
                text={Translate('view-order/clone/modal/failure')}
            />
        </>
    );
};
